// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNullish = (value: any): value is null | undefined =>
  value === null || value === undefined;

export const isNotNullish = <Value>(
  value: Value,
): value is NonNullable<Value> => value !== null && value !== undefined;

export type NonVoid<T> = Exclude<T, undefined | null> extends never ? void : T;
